module.exports = __webpack_public_path__ + "static/media/IMG_2642.c2f09cae.jpg";